<template>
  <div class="serve-action">
    <div class="serve-action-page-title">Serve</div>
    <div class="serve-action-count-row">
      <div
        v-for="n in serveCount"
        :key="n"
        class="serve-action-count"
        :class="{ 'serve-action-count-won': n < serveCount }"
      >#{{ n }}</div>
    </div>
    <div class="serve-player-card"> 
      <img
        v-if="serverSlot && serverSlot.player && serverSlot.player.photo"
        class="serve-player-photo"
        :src="getPhotoUrl(serverSlot.player)"
        :alt="serverSlot.player.name"
      />
      <div class="serve-player-info">
        <span v-if="serverSlot && serverSlot.player" class="serve-player-number">
          {{ serverSlot.player.number }}
        </span>
        <span class="serve-player-name">
          {{ serverSlot && serverSlot.player ? serverSlot.player.name : 'None' }}
        </span>
        <span v-if="serverSlot && serverSlot.roleCode" class="serve-player-role">
          {{ serverSlot.roleCode }}
        </span>
      </div>

      <div v-if="serverSlot && serverSlot.player" class="serve-player-stats">
        <div class="serve-player-stats-rating" :class="{ 'inactive': !getPlayerStats(serverSlot.player).total > 0 }">{{ getPlayerStats(serverSlot.player).rating }}
          <div class="serve-player-stats-box">
            <span class="serve-player-stats-count">{{ getPlayerStats(serverSlot.player).pts }}</span>
            <span class="serve-player-stats-pct">{{ getPlayerStats(serverSlot.player).total ? Math.round(getPlayerStats(serverSlot.player).pts / getPlayerStats(serverSlot.player).total * 100) : 0 }}%</span>
          </div>
        </div>
        <div class="serve-player-stats-breakdown">
          <div v-for="r in [4, 3, 2, 1, 0]" :key="r" class="serve-player-stats-box" :class="'rating-' + r">
            <span class="serve-player-stats-count">{{ getPlayerStats(serverSlot.player)['r' + r] }}</span>
            <span class="serve-player-stats-pct">{{ getPlayerStats(serverSlot.player).total ? Math.round(getPlayerStats(serverSlot.player)['r' + r] / getPlayerStats(serverSlot.player).total * 100) : 0 }}%</span>
          </div>
        </div>
      </div>

      <div v-if="selectedPlayer && selectedPlayer.name" class="serve-player-rating">
        <button
          v-for="rating in ratings"
          :key="rating"
          class="serve-player-rating-button"
          :class="{
            error: rating === 0,
            ace: rating === 4
          }"
          :disabled="Boolean(selectedCall)"
          @click="selectRating(rating)"
        >
          {{ getServeRatingLabel(rating) }}
        </button>
      </div>
    </div>

    <div v-if="selectedPlayer && selectedPlayer.name" class="serve-other-outcomes">
      <label
        class="serve-outcome-button secondary won"
        :class="{
          selected: selectedCall === 'Opposition Rotation Error',
          won: selectedCall === 'Opposition Rotation Error'
        }"
      >
        <input
          type="radio"
          value="Opposition Rotation Error"
          v-model="selectedCall"
          @click="toggleCall('Opposition Rotation Error', $event)"
        />
        Opposition rotation error
      </label>
      <label
        class="serve-outcome-button secondary lost"
        :class="{
          selected: selectedCall === 'Rotation Error',
          lost: selectedCall === 'Rotation Error'
        }"
      >
        <input
          type="radio"
          value="Rotation Error"
          v-model="selectedCall"
          @click="toggleCall('Rotation Error', $event)"
        />
        Team rotation error
      </label>
    </div>

  </div>
</template>

<script>
import { store } from '../store.js';

export default {
  name: 'ServeAction',
  props: {
    currentPoint: {
      type: Object,
      required: true
    }
  },
  data() {
    const initialPlayer = this.currentPoint?.serveAction?.player;
    const hasPlayer = initialPlayer && (initialPlayer.name || initialPlayer.number !== undefined);
    return {
      selectedPlayer: hasPlayer ? initialPlayer : null,
      selectedRating: this.currentPoint?.serveAction?.rating ?? null,
      selectedCall: this.currentPoint?.serveAction?.call ?? null,
      ratings: [4, 3, 2, 1, 0]
    };
  },
  computed: {
    serveCount() {
      const points = store.getCurrentSet()?.points || [];
      let count = 1;
      for (let i = points.length - 1; i >= 0; i--) {
        if (points[i].startPoint === 'Serve') {
          count++;
        } else {
          break;
        }
      }
      return count;
    },
    currentLineup() {
      return store.currentLineup;
    },
    serverSlot() {
      return this.currentLineup.find(item => item.rotationPosition === 1) || null;
    },
    playerServeStats() {
      const stats = new Map();
      const sets = store.match?.sets || [];
      for (const set of sets) {
        const points = set.points || [];
        for (const point of points) {
          const sa = point.serveAction;
          if (!sa || !sa.player || !sa.player.number || sa.rating == null) continue;
          const num = sa.player.number;
          if (!stats.has(num)) {
            stats.set(num, { total: 0, r4: 0, r3: 0, r2: 0, r1: 0, r0: 0, pts: 0, rating: '0.00' });
          }
          const s = stats.get(num);
          s.total++;
          if (sa.rating === 4) s.r4++;
          else if (sa.rating === 3) s.r3++;
          else if (sa.rating === 2) s.r2++;
          else if (sa.rating === 1) s.r1++;
          else if (sa.rating === 0) s.r0++;
          // Count points won on serve
          if (point.startPoint === 'Serve' && point.scoreAction?.outcome === 'Won') {
            s.pts++;
          }
          s.rating = s.total > 0 ? ((s.r4 * 4 + s.r3 * 3 + s.r2 * 2 + s.r1 * 1 + s.pts * 0.5) / s.total).toFixed(2) : '0.00';
        }
      }
      return stats;
    }
  },
  watch: {
    'currentPoint.serveAction'(nextAction) {
      if (!nextAction) {
        return;
      }
      const nextPlayer = nextAction.player;
      const hasPlayer = nextPlayer && (nextPlayer.name || nextPlayer.number !== undefined);
      this.selectedPlayer = hasPlayer ? nextPlayer : null;
      this.selectedRating = nextAction.rating ?? null;
      this.selectedCall = nextAction.call ?? null;
      if (
        (!this.selectedPlayer || !this.selectedPlayer.name) &&
        this.serverSlot &&
        this.serverSlot.player
      ) {
        this.selectedPlayer = this.serverSlot.player;
        this.updateSelection();
      }
    }
  },
  mounted() {
    // Automatically select the player from position 1
    const playerFromPosition1 = this.serverSlot;
    if (!this.selectedPlayer && playerFromPosition1 && playerFromPosition1.player) {
      this.selectedPlayer = playerFromPosition1.player;
      this.updateSelection();
    }
  },
  methods: {
    getPlayerStats(player) {
      if (!player || !player.number) return { total: 0, r4: 0, r3: 0, r2: 0, r1: 0, r0: 0, pts: 0, rating: '0.00' };
      return this.playerServeStats.get(player.number) || { total: 0, r4: 0, r3: 0, r2: 0, r1: 0, r0: 0, pts: 0, rating: '0.00' };
    },
    getPhotoUrl(player) {
      try {
        if (player && player.photo) {
          return require(`@/assets/${player.photo}`);
        }
        return require('@/assets/player-photos/placeholder.png');
      } catch (error) {
        return require('@/assets/player-photos/placeholder.png');
      }
    },
    getServeRatingLabel(rating) {
      if (rating === 0) {
        return 'Serve Error';
      }
      if (rating === 4) {
        return 'Ace';
      }
      return rating;
    },
    updateSelection() {
      this.$emit('update-first-set', 'serveAction', {
        player: this.selectedPlayer,
        rating: this.selectedRating,
        call: this.selectedCall
      });
    },
    selectRating(rating) {
      if (this.selectedRating === rating) {
        this.selectedRating = null;
      } else {
        this.selectedRating = rating;
      }
      this.selectedCall = null;
      this.updateSelection();
    },
    toggleCall(call, event) {
      if (this.selectedCall === call) {
        event.preventDefault();
        this.selectedCall = null;
        this.updateSelection();
        return;
      }
      this.selectedCall = call;
      this.selectedRating = null;
      this.updateSelection();
    },
    resetSelectedPlayer() {
      this.selectedRating = null;
      this.selectedCall = null;
    },
    updateSelectedPlayer(substitutedPlayer, newPlayer) {
      if (this.selectedPlayer && this.selectedPlayer.id === substitutedPlayer.id) {
        this.selectedPlayer = newPlayer;
      }
      this.updateSelection();
    }
  }
};
</script>

<style lang="scss">
.serve-action {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: calc(100% - 40px);
  max-width: 900px;
  margin: 0 auto;

}

.serve-action-page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.serve-action-count-row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin: 0 0 12px 0;
}

.serve-action-count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 11px;
  color: var(--white);
  font-weight: 500;
  border-radius: 40px;
  border: 1px dashed rgb(from var(--white) r g b / 0.5);
  flex-shrink: 0;
}

.serve-action-count-won {
  background-color: var(--green-500);
  border-color: var(--green-500);
  color: var(--white);
}

.serve-player-card {
  color: var(--grey-900);
  border-radius: 20px;
  display: flex;
  gap: 10px;
  width: 100%;
  height: 300px;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  padding-top: 100px;

  &::before {
    content: '';
    position: absolute;
    background-color: var(--grey-20);
    bottom: 0;
    top: 80px;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    background: linear-gradient(
      0deg,
      rgb(from var(--grey-1000) r g b / 0.1) 0%,
      rgb(from var(--grey-1000) r g b / 0) 50%
    );
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.serve-player-photo {
  position: absolute;
  bottom: 0;
  left: -100px;
  bottom: 0;
  height: 100%;
  object-fit: cover;
}

.serve-player-info {
  font-weight: 500;
  padding: 0 25px;
  border-radius: 100px;
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
  .serve-player-number {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 100px;
    border: 1px solid var(--grey-200);
    background-color: var(--white);
    margin: 0;
    letter-spacing: -0.025rem;
    font-weight: 700;
    font-size: 16px;
    width: 30px;
  }

  .serve-player-name {
    font-weight: 700;
    font-size: 16px;
  }

  .serve-player-role {
    width: 30px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    background-color: var(--grey-50);
    border-radius: 4px;
  }
}

.serve-player-stats {
  z-index: 2;
  padding: 8px 16px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.serve-player-stats-rating {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  color: var(--grey-900);
  letter-spacing: -0.05em;
  display: flex;
  align-items: center;
  gap: 8px;

  &.inactive {
    color: rgb(from var(--grey-900) r g b / 0.35);
  }
}

.serve-player-stats-breakdown {
  display: flex;
  gap: 8px;
  flex: 1;
}

.serve-player-stats-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-radius: 10px;
  background-color: rgb(from var(--grey-1000) r g b / 0.02);
  padding: 0;
  height: 50px;
  width: 70px;
  box-sizing: border-box;

  &.rating-4 {
    background-color: rgb(from var(--green-500) r g b / 0.05);

    .serve-player-stats-count {
      color: var(--green-600);
    }
    .serve-player-stats-pct {
      color: rgb(from var(--green-600) r g b / 0.35);
    }
  }

  &.rating-0 {
    background-color: rgb(from var(--red-500) r g b / 0.05);

    .serve-player-stats-count {
      color: var(--red-500);
    }
    .serve-player-stats-pct {
      color: rgb(from var(--red-500) r g b / 0.35);
    }
  }
}

.serve-player-stats-count {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--grey-900);
}

.serve-player-stats-pct {
  font-size: 10px;
  font-weight: 500;
  color: rgb(from var(--grey-900) r g b / 0.35);
  line-height: 1.2;
  letter-spacing: 0 !important;
}

.serve-player-rating {
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 2;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 16px 16px 32px;
}

.serve-player-rating-button {
  width: 70px;
  height: 70px;
  border-radius: 100px;
  padding: 8px;
  box-sizing: border-box;
  background: var(--grey-15);
  font-size: 22px;
  line-height: 1;
  font-weight: 700;
  border: 0;
  color: var(--grey-900);
  cursor: pointer;
  position: relative;
  transition: all 0.1s cubic-bezier(.4,0,0,1);

  &::before {
    content: '';
    position: absolute;
    background-color: var(--grey-1000);
    opacity: 0;
    inset: 0;
    border-radius: 100px;
    z-index: 4;
    transition: opacity 0.2s cubic-bezier(.4,0,0,1);
  }

  &:hover {
    background: var(--white);
    box-shadow: 0 0 0px 8px rgba(0, 0, 0, 0.15), 0 0 8px rgba(0, 0, 0, 0.5);
  }

  &.ace {
    background: var(--green-500);
    color: var(--white);
    font-size: 12px;

    &:hover {
      background: var(--green-400);
    }
  }

  &.error {
    background: var(--red-400);
    color: var(--white);
    font-size: 12px;

    &:hover {
      background: var(--red-300);
    }
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.serve-other-outcomes {
  position: absolute;
  display: flex;
  bottom: 70px;
  left: 10px;
  right: 10px;
  justify-content: space-between;
}

.serve-outcome-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--grey-15);
  align-content: center;
  gap: 10px;
  cursor: pointer;
  aspect-ratio: 1;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  text-align: center;
  width: 120px;
  height: 30px;
  padding: 10px;
  font-size: 12px;

  input {
    display: none;
  }

  &.primary {
    &.won {
      background-color: var(--green-500);
      color: var(--white);
      border: 1px solid var(--green-500);

      &:hover {
        background-color: var(--green-600);
        border-color: var(--green-600);
      }
    }

    &.lost {
      background-color: var(--red-300);
      color: var(--white);
      border: 1px solid var(--red-300);

      &:hover {
        background-color: var(--red-400);
        border-color: var(--red-400);
      }
    }
  }

  &.secondary {
    &.won {
      background-color: transparent;
      color: var(--green-500);
      border: 1px solid var(--green-500);

      &:hover {
        color: var(--green-300);
        border: 1px solid var(--green-300);
      }
    }

    &.lost {
      background-color: transparent;
      color: var(--red-200);
      border: 1px solid var(--red-200);

      &:hover {
        color: var(--red-100);
        border: 1px solid var(--red-100);
      }
    }
  }
}
</style>
